export default function sidebarHelper(Alpine) {
  Alpine.data("sidebarHelper", () => ({
    open: false,
    isTouch: false,
    hoverTimeout: null,

    // Open immediately, cancel any pending close
    show() {
      if (this.isTouch) return;
      clearTimeout(this.hoverTimeout);
      this.open = true;
    },

    // Close after 150ms to allow crossing the gap
    hide() {
      if (this.isTouch) return;
      this.hoverTimeout = setTimeout(() => {
        this.open = false;
      }, 150);
    },

    // Toggle logic for mobile/touch
    toggle() {
      if (this.isTouch) {
        this.open = !this.open;
      }
    },
  }));
}
